import { EditorState } from '../types';

/**
 * 선택된 트랜지션 ID들을 삭제합니다.
 */
export const deleteTransitions = (
  state: EditorState,
  transitionIds: string[],
): EditorState => {
  if (transitionIds.length === 0) {
    return state;
  }

  const newTransitions = { ...state.undoableState.transitions };

  // 삭제할 트랜지션들을 제거
  for (const transitionId of transitionIds) {
    delete newTransitions[transitionId];
  }

  // 선택 목록에서 삭제된 트랜지션 제거
  const newSelectedItems = state.selectedItems.filter(
    (id) => !transitionIds.includes(id),
  );

  return {
    ...state,
    undoableState: {
      ...state.undoableState,
      transitions: newTransitions,
    },
    selectedItems: newSelectedItems,
  };
};

/**
 * 특정 트랜지션이 선택 목록에서 트랜지션인지 확인합니다.
 */
export const isTransitionId = (state: EditorState, itemId: string): boolean => {
  return itemId in state.undoableState.transitions;
};

/**
 * 선택된 아이템들 중 트랜지션 ID만 추출합니다.
 */
export const getSelectedTransitionIds = (state: EditorState): string[] => {
  return state.selectedItems.filter((id) => isTransitionId(state, id));
};

/**
 * 선택된 아이템들 중 일반 아이템 ID만 추출합니다 (트랜지션 제외).
 */
export const getSelectedNonTransitionIds = (state: EditorState): string[] => {
  return state.selectedItems.filter((id) => !isTransitionId(state, id));
};
